/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Center__Refund_Policy__Returns__Cooloff_PeriodInputs */

const en_help_center__refund_policy__returns__cooloff_period = /** @type {((inputs: Help_Center__Refund_Policy__Returns__Cooloff_PeriodInputs) => LocalizedString) & { parts: (inputs: Help_Center__Refund_Policy__Returns__Cooloff_PeriodInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Help_Center__Refund_Policy__Returns__Cooloff_PeriodInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (`14-Day Cooling-Off Period: In accordance with EU consumer law, you have 14 days to return unopened products for a full refund (shipping costs excluded).`)
		}),
		{
			parts: /** @type {(inputs: Help_Center__Refund_Policy__Returns__Cooloff_PeriodInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-start", name: "strong", options: {}, attributes: {} }, { type: "text", value: "14-Day Cooling-Off Period:" }, { type: "markup-end", name: "strong", options: {}, attributes: {} }, { type: "text", value: " In accordance with EU consumer law, you have 14 days to return unopened products for a full refund (shipping costs excluded)." }])
			})
		}
	)
);

/**
* | output |
* | --- |
* | "14-Day Cooling-Off Period: In accordance with EU consumer law, you have 14 days to return unopened products for a full refund (shipping costs excluded)." |
*
* @param {Help_Center__Refund_Policy__Returns__Cooloff_PeriodInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const help_center__refund_policy__returns__cooloff_period = /** @type {((inputs?: Help_Center__Refund_Policy__Returns__Cooloff_PeriodInputs, options?: { locale?: "en" }) => LocalizedString) & { parts: (inputs?: Help_Center__Refund_Policy__Returns__Cooloff_PeriodInputs, options?: { locale?: "en" }) => import('../runtime.js').MessagePart[] } & import('../runtime.js').MessageMetadata<Help_Center__Refund_Policy__Returns__Cooloff_PeriodInputs, { locale?: "en" }, { strong: { options: {}; attributes: {}; children: true } }>} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs?: Help_Center__Refund_Policy__Returns__Cooloff_PeriodInputs, options?: { locale?: "en" }) => LocalizedString} */ ((inputs = {}, options = {}) => {
			const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
			return en_help_center__refund_policy__returns__cooloff_period(inputs)
		}),
		{
			parts: /** @type {(inputs?: Help_Center__Refund_Policy__Returns__Cooloff_PeriodInputs, options?: { locale?: "en" }) => import('../runtime.js').MessagePart[]} */ ((inputs = {}, options = {}) => {
				const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
				return typeof en_help_center__refund_policy__returns__cooloff_period.parts === "function" ? en_help_center__refund_policy__returns__cooloff_period.parts(inputs) : [{ type: "text", value: en_help_center__refund_policy__returns__cooloff_period(inputs) }]
			})
		}
	)
);